import { BaseModel } from '../base-model';
import ItemStateStatus from '../../common/item-state.constant';
import { IGenericObject } from '../common';

export interface IPropertyRelationModel {
  Id?: number;
  PropertyId?: number;  //ObjectID
  PersonId?: number;  //PersonID
  RelationTypeId?: number;  //TypeID
  Comment?: string;
  IsMain?: boolean;  //Main
  IsSendReport?: boolean  //IncludeInMailing
  PersonIndex?: number; //PNr
  C21ContactListingId?: string;
  Confirm?: number;
  Time?: number;
  IsSendAppointmentConfirmations?: boolean;  //SendAppointmentConfirmations
  //Custom
  PersonName?: string;
  PersonFirstName?: string;
  PersonCompanyName?: string;
  PersonReference?: string;
  PersonEmail?: string;
  PersonEmail2?: string;
  PersonEmail3?: string;
  PersonComment?: string;
  PersonCityName?: string;
  RelationTypeNameNL?: string;
  RelationTypeNameFR?: string;
  RelationTypeNameEN?: string;
  ItemState?: number;
  PersonTypeInfo?: IGenericObject;
  getPersonTypeInfo?: any;
  PersonEmails?: string[];
  PersonPhones?: any;
  RelationTypeNameDE?: string;
  CompanyName?: string;
  PersonCountryId?: number;
  PersonLanguageId?: number;
  PersonPostCode?: string;
  PersonStreet?: string;
  PersonStreet2?: string;
  PhoneDesc3?: string;
  PhoneDesc2?: string;
  PhoneDesc1?: string;
  PhoneDesc4?: string;
  PhoneDesc5?: string;
  PhoneDesc6?: string;
  PhoneDesc7?: string;
  PhoneDesc8?: string;
  PhoneDesc9?: string;
  PhoneDesc10?: string;
  PersonHouseNumber?: string;
  PhoneNumber1?: string;
  PhoneNumber2?: string;
  PhoneNumber3?: string;
  PhoneNumber4?: string;
  PhoneNumber5?: string;
  PhoneNumber6?: string;
  PhoneNumber7?: string;
  PhoneNumber8?: string;
  PhoneNumber9?: string;
  PhoneNumber10?: string;
  PersonBoxNumber?: string;
  PersonVAT?: string;
  PersonIDCardNumber?: string;
  PersonBirthday?: string;
  PersonBirthplace?: string;
  CompanyId?: number;
    StartCommercialisation?: string;
    NeverSendMail?: boolean;
}
export class PropertyRelationModel extends BaseModel<IPropertyRelationModel> implements IPropertyRelationModel {
  Id: number;
  PropertyId: number;  //ObjectID
  PersonId: number;  //PersonID
  RelationTypeId: number;  //TypeID
  Comment: string;
  IsMain: boolean;  //Main
  IsSendReport: boolean  //IncludeInMailing
  PersonIndex: number; //PNr
  C21ContactListingId: string;
  Confirm: number;
  Time: number;
  IsSendAppointmentConfirmations: boolean;  //SendAppointmentConfirmations
  //Custom
  PersonName: string;
  PersonFirstName: string;
  PersonCompanyName: string;
  PersonReference: string;
  PersonEmail: string;
  PersonEmail2?: string;
  PersonEmail3?: string;
  PersonComment: string;
  PersonCityName: string;
  RelationTypeNameNL: string;
  RelationTypeNameFR: string;
  RelationTypeNameEN: string;
  ItemState: number;
  PersonTypeInfo?: IGenericObject;
  PersonEmails?: string[];
  PersonPhones?: any;
  RelationTypeNameDE?: string;
  CompanyName?: string;
  PersonCountryId?: number;
  PersonLanguageId?: number;
  PersonPostCode?: string;
  PersonStreet?: string;
  PersonStreet2?: string;
  PhoneDesc3?: string;
  PhoneDesc2?: string;
  PhoneDesc1?: string;
  PhoneDesc4?: string;
  PhoneDesc5?: string;
  PhoneDesc6?: string;
  PhoneDesc7?: string;
  PhoneDesc8?: string;
  PhoneDesc9?: string;
  PhoneDesc10?: string;
  PersonHouseNumber?: string;
  PhoneNumber1?: string;
  PhoneNumber2?: string;
  PhoneNumber3?: string;
  PhoneNumber4?: string;
  PhoneNumber5?: string;
  PhoneNumber6?: string;
  PhoneNumber7?: string;
  PhoneNumber8?: string;
  PhoneNumber9?: string;
  PhoneNumber10?: string;
  PersonBoxNumber?: string;
  PersonVAT?: string;
  PersonIDCardNumber?: string;
  PersonBirthday?: string;
  PersonBirthplace?: string;
  CompanyId?: number;
  StartCommercialisation?: string;
    NeverSendMail?: boolean;
  getPersonTypeInfo(source: IGenericObject[]) {
    if (this.RelationTypeId !== undefined)
      return this.PersonTypeInfo = source.find(type => type.Id === this.RelationTypeId);
    return {};
  }
  
  /**
   *
   */
  constructor(option?: IPropertyRelationModel) {
    super(option);
    this.ItemState = ItemStateStatus.Added;
    this.PersonId = this.PersonId|| null;
    this.PersonReference = this.PersonReference|| null;
    this.RelationTypeId = this.RelationTypeId|| null;
    this.Comment = this.Comment|| null;
    this.PersonIndex = this.PersonIndex|| 1;
    this.IsSendReport = this.IsSendReport|| false;
    this.IsSendAppointmentConfirmations = this.IsSendAppointmentConfirmations|| false;
  }
}

/**
 * UPDATE WITH SPECIFIC FIELD
 */
export class PropertyRelationUpdateModel  {
  Id: number;
  Field: string;
  Value: object
}
